import React from "react";
import { FaTimesCircle } from "react-icons/fa";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "../../hooks/useTranslation";

const PaymentFailed = () => {
  const { t } = useTranslation();
  const currentLocation = useLocation();

  const params = new URLSearchParams(currentLocation.search);
  const redirectUrl = params.get("redirect_url");

  const handleRedirect = () => {
    let url = "";
    if (redirectUrl) {
      url = redirectUrl;
    } else {
      url = process.env.REACT_APP_URL || window.location.origin || "/";
    }

    window.location.href = url;
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <FaTimesCircle style={styles.icon} />
        <h1 style={styles.heading}>{t("paymentFailed").title}</h1>
        <p style={styles.message}>{t("paymentFailed").message}</p>
        <button onClick={handleRedirect} style={styles.button}>
          <FiArrowLeft style={{ marginRight: "8px" }} />
          {t("paymentFailed").goBack}
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    background: "linear-gradient(135deg, #28a745, #ff7f00)", // green + orange
    padding: "1rem",
  },
  card: {
    backgroundColor: "#fff",
    padding: "2rem",
    borderRadius: "16px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
    textAlign: "center",
    maxWidth: "400px",
    width: "100%",
    animation: "fadeIn 0.6s ease-in-out",
  },
  icon: {
    fontSize: "4rem",
    color: "#e74c3c", // red for failure
    marginBottom: "1rem",
  },
  heading: {
    color: "#333",
    fontSize: "2rem",
    fontWeight: "bold",
    marginBottom: "0.5rem",
  },
  message: {
    fontSize: "1.1rem",
    marginBottom: "2rem",
    color: "#555",
  },
  button: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0.75rem 1.5rem",
    backgroundColor: "#28a745", // green button
    color: "#fff",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: "600",
    fontSize: "1rem",
    transition: "all 0.3s ease",
  },
};

// Keyframes for fadeIn (optional, add in global CSS)
// @keyframes fadeIn {
//   from { opacity: 0; transform: translateY(20px); }
//   to { opacity: 1; transform: translateY(0); }
// }

export default PaymentFailed;
